<template>
  <v-dialog
    v-model="show"
    persistent
    max-width="500px"
    overlay-opacity="0.85"
    z-index="9999"
  >
    <v-card class="loading-card">
      <v-card-title class="d-flex align-center justify-center">
        <v-icon color="primary" class="mr-3">mdi-file-excel</v-icon>
        <span class="text-h6 font-weight-bold">{{ title }}</span>
      </v-card-title>

      <v-card-text class="pb-6">
        <div class="text-center mb-4">
          <v-icon
            class="rotating-icon spin"
            color="primary"
            size="64"
          >
            mdi-cog
          </v-icon>
        </div>

        <!-- Mensaje de estado -->
        <div class="info-section">
          <div class="text-center">
            <v-icon color="info" class="mb-2">mdi-information</v-icon>
            <p class="mb-0 font-weight-medium">{{ message }}</p>
            <p class="caption text--secondary mt-2">
              Por favor espere, esto puede tomar algunos momentos...
            </p>
          </div>
        </div>

        <!-- Tiempo transcurrido -->
        <div class="text-center mt-4">
          <small class="text--secondary">
            <v-icon small class="mr-1">mdi-timer</v-icon>
            Tiempo transcurrido: {{ formatTime(elapsedTime) }}
          </small>
        </div>
      </v-card-text>

      <!-- Botones de acción -->
      <v-card-actions class="pa-4 pt-0">
        <v-btn
          text
          color="error"
          @click="$emit('cancel')"
          class="cancel-btn"
        >
          <v-icon left small>mdi-close-circle</v-icon>
          Cancelar
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          @click="$emit('background')"
          class="background-btn"
          elevation="2"
        >
          <v-icon left small>mdi-download</v-icon>
          Continuar en segundo plano
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'LoadingDialog',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Exportando a Excel'
    },
    message: {
      type: String,
      default: 'Generando archivo de exportación...'
    }
  },
  data() {
    return {
      startTime: null,
      elapsedTime: 0,
      timer: null
    };
  },
  watch: {
    show(newVal) {
      if (newVal) {
        this.startTimer();
      } else {
        this.stopTimer();
      }
    }
  },
  methods: {
    startTimer() {
      this.startTime = Date.now();
      this.timer = setInterval(() => {
        this.elapsedTime = Date.now() - this.startTime;
      }, 1000);
    },
    stopTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      this.elapsedTime = 0;
    },
    formatTime(milliseconds) {
      if (!milliseconds || milliseconds <= 0) return '0s';

      const seconds = Math.floor(milliseconds / 1000);
      const minutes = Math.floor(seconds / 60);
      const hours = Math.floor(minutes / 60);

      if (hours > 0) {
        return `${hours}h ${minutes % 60}m ${seconds % 60}s`;
      } else if (minutes > 0) {
        return `${minutes}m ${seconds % 60}s`;
      } else {
        return `${seconds}s`;
      }
    }
  },
  beforeDestroy() {
    this.stopTimer();
  }
};
</script>

<style scoped>
.loading-card {
  border-radius: 12px !important;
  z-index: 10000 !important;
}

.rotating-icon {
  transition: transform 0.3s ease;
}

.rotating-icon.spin {
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.info-section {
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 24px;
  border: 1px solid #e9ecef;
}

.v-card-title {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white !important;
}

.v-card-title .v-icon {
  color: white !important;
}

.v-card-title span {
  color: white !important;
}

.cancel-btn {
  text-transform: none !important;
  font-weight: 500;
}

.cancel-btn:hover {
  background-color: rgba(244, 67, 54, 0.1) !important;
}

.background-btn {
  text-transform: none !important;
  font-weight: 600;
}

.background-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4) !important;
}

.v-card-actions {
  background-color: #fafafa;
  border-top: 1px solid #e9ecef;
}
</style>
